export default __webpack_public_path__ + "static/media/kris.7db9adea.png";